import { DiscountType } from "@/data/model/Enums";

export class DiscountUtil {
    public static getDiscountIcon(discountType: DiscountType | undefined): string {
        if (discountType === DiscountType.Absolute) {
            return "fa-light fa-tag";
        } else if (discountType === DiscountType.Percentage) {
            return "fa-light fa-percent";
        }
        return "";
    }
}